import { defineComponent } from "vue";
import common from "../core/core";
import { $ref } from "vue/macros";

export default defineComponent({
  data() {
    return {
      supportItemIndex: [],
      supportSubItemIndex: {} as any,
    };
  },
  mounted() {
    this.AppService.faqSubject.subscribe((data) => {
      const markers = document.querySelectorAll(".faq-block-marker");
      if (markers[data.tabIndex] === this.$refs.faqBlockMarker) {
        if (data.type === "category") {
          if (!this.supportItemIndex.includes(data.index)) {
            this.toggleSuppItem(data.index);
          }
          data.el?.scrollIntoView({ block: "center", behavior: "smooth" });
        }
        if (data.type === "question" || data.type === "answer") {
          if (!this.supportItemIndex.includes(data.categoryIndex)) {
            this.toggleSuppItem(data.categoryIndex);
          }
          if (!this.supportSubItemIndex[data.categoryIndex].includes(data.questionIndex)) {
            this.toggleSuppSub(data.categoryIndex, data.questionIndex);
          }
          data.el?.scrollIntoView({ block: "center", behavior: "smooth" });
        }
      }
    });
  },
  computed: {},
  methods: {
    toggleSuppItem(index: number) {
      if (this.supportItemIndex.includes(index)) {
        const i = this.supportItemIndex.findIndex((i) => i === index);
        if (i > -1) {
          this.supportItemIndex.splice(i, 1);
        }
      } else {
        this.supportItemIndex.push(index);
      }
      this.supportSubItemIndex[index] = [];
    },
    toggleSuppSub(parentIndex: number, index: number) {
      if (!this.supportSubItemIndex[parentIndex]?.length) {
        this.supportSubItemIndex[parentIndex] = [];
      }
      if (this.supportSubItemIndex[parentIndex].includes(index)) {
        const i = this.supportSubItemIndex[parentIndex].findIndex((i: any) => i === index);
        if (i > -1) {
          this.supportSubItemIndex[parentIndex].splice(i, 1);
        }
      } else {
        this.supportSubItemIndex[parentIndex].push(index);
      }
    },
    isActiveItem(id: number) {
      return this.supportItemIndex.includes(id);
    },
    isActiveSubItem(id: number, subId: number) {
      return this.supportSubItemIndex[id]?.includes(subId);
    },
  },
  mixins: [common],
});
